export default __webpack_public_path__ + "static/media/p1.96abb730.png";